import { connect } from 'react-redux';
import { areGcSalesDisabledForBarber } from '../../shops/selectors';

export default connect(state => ({
  areGcSalesDisabledForBarber: areGcSalesDisabledForBarber(state),
}));



// WEBPACK FOOTER //
// ./src/app/giftCard/hoc/withAreGcSalesDisabledForBarber.js